import React from "react";

interface TabButtonProps {
    tab: string;
    activeTab: string;
    onClick: (tab: string) => void;
    children: React.ReactNode;
}

const TabButton = ({ tab, activeTab, onClick, children }: TabButtonProps) => (
    <button
        onClick={() => onClick(tab)}
        className={`px-4 py-2 ${activeTab === tab ? "bg-green-700 text-white" : "bg-gray-300 text-gray-700"} tab-button-hover p-4 `}
    >
        {children}
    </button>
);

export default TabButton;
